import { Injectable, Provider, inject } from '@angular/core';

import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { DbContext } from '../../core/utils/db-context';
import { UserModel } from '../../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class ProvidersRepository extends BaseEntityRepository<UserModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(r => r.tableName === DbContext.Providers);
    }

    async getByProvidersIds(providersIds: any[]): Promise<UserModel[]> {
        let result: UserModel[] = [];

        await this.database.transaction(this.config.tableName).store.openCursor().then(async (cursor) => {
            while (cursor) {
                const model = cursor.value as UserModel;

                if (providersIds.includes(model.id)) {
                    result.push(model);
                }

                result.includes(model);

                cursor = await cursor.continue();
            }
        });


        return result;
    }
}
